export interface DynamicFormField {
    type?: string;
    name?: string;
    field?: string;
    label?: string;
    title?: string;
    required?: boolean | string | number;
}

export function isDynamicFieldRequired(field: DynamicFormField): boolean {
    return field.required !== false && (field.required === true || field.required === 'true' || field.required === 1);
}

export function fieldKey(field: DynamicFormField, index: number): string {
    return field.name || field.field || `field_${index}`;
}

export function validateDynamicFormFields(
    fields: DynamicFormField[],
    values: Record<string, string>,
): { valid: boolean; errors: Record<string, string>; firstInvalidKey: string | null } {
    const errors: Record<string, string> = {};
    let firstInvalidKey: string | null = null;

    fields.forEach((field, index) => {
        if (!isDynamicFieldRequired(field)) return;
        const key = fieldKey(field, index);
        const raw = values[key] ?? '';
        const trimmed = String(raw).trim();
        if (!trimmed) {
            errors[key] = 'required';
            if (!firstInvalidKey) firstInvalidKey = key;
            return;
        }
        const type = (field.type || 'text').toLowerCase();
        if (type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
            errors[key] = 'email';
            if (!firstInvalidKey) firstInvalidKey = key;
        }
    });

    return { valid: Object.keys(errors).length === 0, errors, firstInvalidKey };
}
